export const FILTER_DISPLAY = {
	DEFAULT: "default",
	BUTTONS: "buttons",
};
